import { useTranslation } from "react-i18next";

import { faGavel, faUserShield, faClockRotateLeft } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";

const ITEM_ICONS = [faGavel, faUserShield, faClockRotateLeft];

type RiskItem = {
	title: string;
	description: string;
};

export default function LandingRiskSection() {
	const { t } = useTranslation();
	const ts = (key: string) => t(`questionnaire.landingRisk.${key}`);

	const items = t("questionnaire.landingRisk.items", {
		returnObjects: true,
	}) as RiskItem[];

	return (
		<section className="w-full px-4 md:px-0 bg-ink">
			<div className="w-full max-w-[1420px] mx-auto py-16 sm:py-24 px-4 md:px-16 flex flex-col gap-12">
				<div className="flex flex-col items-center gap-4 text-center max-w-[820px] mx-auto">
					<span className="font-urbanist text-[13px] font-bold uppercase tracking-[0.12em] text-warning bg-white/5 border border-warning/30 rounded-full px-4 py-1.5">
						{ts("kicker")}
					</span>
					<h2 className="font-urbanist text-[34px] md:text-[40px] font-semibold leading-[120%] text-white">
						{ts("title")}
					</h2>
					<p className="font-urbanist text-[18px] font-normal leading-[150%] text-white/70">
						{ts("subtitle")}
					</p>
				</div>

				<div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6">
					{items?.map((item, index) => (
						<div
							key={item.title}
							className="flex flex-col gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-7"
						>
							<div className="flex w-12 h-12 shrink-0 rounded-xl bg-warning/15 justify-center items-center">
								<Icon className="w-5 h-5 text-warning" icon={ITEM_ICONS[index]} />
							</div>
							<h3 className="font-urbanist text-[20px] font-bold text-white leading-[130%]">
								{item.title}
							</h3>
							<p className="font-urbanist text-[15px] leading-[160%] text-white/70">
								{item.description}
							</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
